// extracted by mini-css-extract-plugin
export default {"MenuHeader":"Menu_MenuHeader__hsyyc","MenuList":"Menu_MenuList__aB15X","MenuItem":"Menu_MenuItem__mSQZe","active":"Menu_active__CZp+-"};